import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { TStickyBannerMgmt } from '../../../type';
import { ServerMeta } from 'types/common';

type Props = {
    condition?: ServerMeta;
    banner?: TStickyBannerMgmt;
    onEdit: () => void;
};

const StickyBannerContentItem: React.FC<Props> = ({
    condition,
    banner,
    onEdit,
}) => {
    return (
        <div className={s.contentItem}>
            <div className={s.header}>
                <h3 className={s.title}>{condition?.content}</h3>
                <Button
                    onClick={onEdit}
                >
                    Edit
                </Button>
            </div>

            <div className={s.content}>
                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Title</div>
                    <div className={s.dataValue}>{banner?.title}</div>
                </div>
                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Sub text</div>
                    <div className={s.dataValue}>{banner?.subText}</div>
                </div>
                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Call to action name</div>
                    <div className={s.dataValue}>{banner?.callToActionName}</div>
                </div>
                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Call to action link</div>
                    <div className={s.dataValue}>{banner?.callToActionLink}</div>
                </div>
            </div>
        </div>
    );
};

export default StickyBannerContentItem;
